export const Action = {
  Manage: 'manage',
} as const;
